import React from 'react';

import {
    CarFrontIcon,
    GearIcon,
    RearHatchIcon,
    SignalIcon,
    StarRadiatingIcon,
    SteeringWheelIcon,
    TrafficConeIcon,
} from '@iris/react-icons';
import clsx from 'clsx';

import {
    Box,
    Button,
    Carousel,
    Glyphicon,
    Heading,
    Section,
    SubHeading,
    Text,
} from 'reaxl';

function getCarouselHeaderIcon(tabName) {
    switch (tabName) {
        case 'Highlights':
            return <StarRadiatingIcon />;
        case 'safety':
            return <TrafficConeIcon />;
        case 'technology':
            return <SignalIcon />;
        case 'interior':
            return <SteeringWheelIcon />;
        case 'exterior':
            return <CarFrontIcon />;
        case 'Cargo and Capacity':
            return <RearHatchIcon />;
        case 'mechanical':
            return <GearIcon />;
        default:
            return null;
    }
}

/**
 * A carousel that holds cards containing the vehicle's features.
 *
 * @component
 * @param {Object} props
 * @param {string[]} [props.enabledTabs=[]] - Array of string tab names to be rendered as cards in the carousel
 * @param {string} props.sectionHeader - The header text to display above the carousel
 * @returns {JSX.Element} A carousel full of vehicle features cards
 *
 */

export default function VehicleFeaturesCarousel(
    {
        enabledTabs = [],
        sectionHeader,
    }
) {

    enabledTabs.forEach((tab) => {
        if (tab === 'packages' || tab === 'other') {
            enabledTabs.splice(enabledTabs.indexOf(tab), 1);
        }
    });

    const vehicleFeaturesCards = ['Highlights', 'Cargo and Capacity', ...enabledTabs].map((tab) => (
        <Box
            className="margin-right-4 width-full container-sm"
            backgroundColor="neutral-primary"
            borderColor="neutral-secondary"
            key={tab + 'VehicleFeatureCard'}
        >
            <div
                className="margin-left-auto margin-right-auto features-card-icon"
            >
                {getCarouselHeaderIcon(tab)}
            </div>

            <SubHeading
                level={3}
                className="display-flex justify-content-center margin-top-2 text-blue-darkest"
            >
                {tab.charAt(0).toUpperCase() + String(tab).slice(1)}
            </SubHeading>

            <Text
                size={300}
                className="padding-bottom-2"
            >
                {/* This is a placeholder for US1678967 to remove this and add the features  */}
                {Array.from({ length: 6 }, (_, index) => (
                    <div
                        key={index}
                        className={clsx({
                            'margin-top-5': index === 0,
                            'margin-top-4': index !== 0,
                        })}
                    >
                        <Glyphicon glyph="star" />
                        &nbsp;Apple Carplay / Android Auto
                        <br />
                    </div>
                ))}
            </Text>
        </Box>
    ));

    return (
        <Section
            alignment="left"
            className="padding-bottom-5"
        >
            <Heading
                className="padding-bottom-2 padding-top-5 margin-bottom-3"
                level={3}
            >
                {sectionHeader}
            </Heading>
            <Carousel
                cellWidth="300px"
                initialIndex={0}
                fullWidth
                fullHeight
                fullWidthScroll
                scrollItemsCount={1}
            >
                {
                    ...vehicleFeaturesCards
                }
            </Carousel>

            <div className="display-flex justify-content-center">
                <Button
                    className="margin-top-5"
                >
                    View All Features
                </Button>
            </div>
        </Section>
    );
}
